import axios from 'axios';
import { getEndpoint } from './endpoints';

export default {
    state: {
      trackingContractTemplates: [],
    },
    mutations: {
        setTrackingContractTemplates (state, payload) {
          const endpoint = getEndpoint('trackingContractTemplates', null, null, null, payload.contractId).get;

          axios.get(endpoint,  { params: payload.query }).then(response => {
              state.trackingContractTemplates = response.data;
          })
          .catch(error => {
            console.log(error);
          });
        },
    },
    getters: {
        getTrackingContractTemplates(state) {
            return state.trackingContractTemplates;
        },
    },
};
